// Small shared helpers for rendering.
export const R = (n) => 'R' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
export const esc = (s) => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
export const $ = (id, doc = document) => doc.getElementById(id);
export const reducedMotion = () => typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
